import { HttpHeaders } from '@angular/common/http';
export class header {
  public JsonHeader = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*' });
  public FormHeader = new HttpHeaders().append("Content-Disposition", "application/x-www-form-urlencoded");
  public FormWithFileHeader = new HttpHeaders().append("Content-Disposition", "multipart/form-data");
}
